module.exports = __webpack_public_path__ + "Frame397-12343d93.webp";